import React from 'react';
import { Tooltip, Typography } from 'antd';

interface CardNameColumnProps {
  name: string;
}

export default React.memo((props: CardNameColumnProps) => {
  return (
    <Tooltip placement="top" title={props.name}>
      <Typography.Text className="card-name-tiles">{props.name}</Typography.Text>
    </Tooltip>
  );
});
